import React, {FC} from 'react'
import {Box, Text} from '@chakra-ui/react'
import {BundleProduct} from '_app/graphql/generated/graphql'
import {useDynamicProductPrice} from '../hooks/useDynamicProductPrice'
import getPrice from '../../../_app/utils/localized/getPrice'
import {useRouter} from '../../../_app/hooks/useRouter'
import {useTranslation} from 'next-i18next'

interface ProductHeaderProps {
    product: BundleProduct;
}

const Header: FC<ProductHeaderProps> = ({product}) => {
    const {locale} = useRouter()
    const {name} = product
    const omnibus_price = product?.omnibus_price
    const {price, regularPrice } = useDynamicProductPrice(product)
    const {t} = useTranslation('product')
    const style = {
        box: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '5px',
        },
        text: {
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: 0,
        },
        price: {
            maxWidth: {base: 'full', lg: '310px'},
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: 0,
        },
        priceLowest: {
            maxWidth: {base: 'full', lg: '310px'},
            fontSize: '20px',
            fontWeight: 600,
            color: 'red',
            lineHeight: 1.4,
            marginBottom: 0,
        },
        textSmall: {
            maxWidth: {base: 'full', lg: '310px'},
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: 0,
        },
        textSmallDiscount: {
            maxWidth: {base: 'full', lg: '310px'},
            fontSize: '15px',
            fontWeight: 400,
            color: 'red',
            lineHeight: '24px',
            marginBottom: 0,
            marginLeft: '5px',
        },
        priceDiscount: {
            maxWidth: {base: 'full', lg: '310px'},
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: 0,
            color: '#605d5d',
            textDecoration: 'line-through',
            paddingLeft: '5px',
        },
    }
    return (
        <>
            <Box sx={style.box}>
                <Text sx={style.text}>{name}</Text>
            </Box>
            <Box sx={style.box}>
                {
                    price?.value ? (
                        <Box sx={{ display: 'flex', width: '100%' }}>
                            {
                                regularPrice?.value && regularPrice.value !== price?.value && regularPrice.value > price?.value ? (
                                    <Text sx={style.priceLowest}>{getPrice(locale, price?.value, price?.currency, 2, 2)}</Text>
                                ) : (
                                    <Text sx={style.price}>{getPrice(locale, price?.value, price?.currency, 2, 2)}</Text>
                                )
                            }
                        </Box>
                    ) : ''
                }
            </Box>
            {
                regularPrice?.value && price?.value !== null && price?.value !== undefined && regularPrice.value > price?.value ? (
                    <>
                        <Box sx={style.box}>
                            <Text sx={style.textSmall}>{t('PRICE_REGULAR')}</Text>
                            <Box sx={{ display: 'inline-flex' }}>
                                <Text sx={style.priceDiscount}>
                                    {getPrice(locale, regularPrice.value, regularPrice.currency, 2, 2)}
                                </Text>
                                <Text sx={style.textSmallDiscount}>{'(- ' + ((regularPrice.value - price?.value) / regularPrice?.value * 100).toFixed(0) + ' %)'}</Text>
                            </Box>
                        </Box>
                         <Box sx={style.box}>
                            <Text sx={style.textSmall}>{t('OMNIBUS_PRICE')}</Text>
                            <Text
                                sx={style.priceDiscount}>{getPrice(locale, (omnibus_price && omnibus_price !== 0) ? omnibus_price : regularPrice.value, regularPrice.currency, 2, 2)}</Text>
                         </Box>
                    </>
                ) : ''
            }
        </>
    )
}

export default Header
